import React from 'react';
import { motion } from 'framer-motion';
import { WavesIcon } from 'lucide-react';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section className="py-24 px-4 bg-ivory" data-id="element-175" data-mp="26yfrni8ppbmn">
      <div className="max-w-4xl mx-auto" data-id="element-176" data-mp="26xecp2oks4zn">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center mb-12" data-id="element-177" data-mp="26wlg2ujbyvv8">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-navy" data-id="element-178" data-mp="2204g932rqt2b">
            Does This Sound Familiar?
          </h2>
          <p className="text-lg text-graphite leading-relaxed text-left" data-id="element-179" data-mp="1o1wod9klahy0">
            It’s the evening before your next swim lesson. You know your swimmers. You know
            what they need to improve. But you’re still searching for drills, trying to build
            a progression, deciding what to teach first, figuring out how to fill the entire
            session, and wondering whether the activities you selected will actually work for
            that swimmer’s level.
            <br data-id="element-180" data-mp="1u1bwffxc3a11" />
            <br data-id="element-181" data-mp="1tzr9och9gvdq" />
            <span className="text-navy font-medium" data-id="element-182" data-mp="27sqoec97ylk8">
              Not because you don’t know how to teach swimming.
            </span>{' '}
            Because you’ve been forced to build too many lessons from scratch. And when you
            teach several swimmers or groups every week, that planning time adds up quickly.
            The time you should be using to rest, work with more students, or simply finish
            your day ends up being spent preparing the next session.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-183" data-mp="1k34plpwre8cr">
          <h3 className="text-xl font-bold text-navy mb-8 text-center" data-id="element-184" data-mp="2vhru3rqo3ilt">
            The Real Cost of Not Having the Right Teaching System
          </h3>
          <ul className="grid sm:grid-cols-2 gap-3" data-id="element-185" data-mp="1y3zqt2vfc8cw">
            {painPoints.map((point, index) => <motion.li key={point} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex items-start gap-3 bg-pearl-light border border-pearl-dark rounded-xl px-5 py-4" data-id="element-186" data-mp="22636y4t1g14i" data-mpi={index}>
                <WavesIcon size={18} className="text-aqua-dark shrink-0 mt-0.5" data-id="element-187" data-mp="1jf3jx953t1dv" />
                <span className="text-graphite text-sm leading-relaxed" data-id="element-188" data-mp="1o5sgh2vn4ojv">{point}</span>
              </motion.li>)}
          </ul>

          <div className="text-center mt-12 pt-8 border-t border-pearl-dark" data-id="element-189" data-mp="qq52ke8t239m">
            <p className="text-2xl font-serif font-bold text-navy" data-id="element-190" data-mp="voprhhilx0ir">
              Stop giving away your time. Your knowledge is already there.
            </p>
            <p className="text-xl mt-4 text-graphite" data-id="element-191" data-mp="j75kcbx2yhru">
              What you need is a complete system that helps you turn that knowledge into
              structured lessons faster.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}